import { ConcreteEncodable } from "./ConcreteEncodable";

import { ChannelMessageImplEncoder } from "../../encoder/ChannelMessageImplEncoder";

import * as CubiqTS from "../../index";
import { ChannelMessage } from "../ChannelMessage";

export class ChannelMessageImpl extends ConcreteEncodable implements ChannelMessage {
  public static enType: string = "com.bcdfx.service.messaging.impl.ChannelMessageImpl";

  /*FID=1*/
  public channel: CubiqTS.ProducerChannel | null = null;
  /*FID=2*/
  public payLoad: CubiqTS.Encodable | null = null;
  /*FID=3*/
  public startTime: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ChannelMessageImplEncoder.Instance;
    this.setEncodableType(ChannelMessageImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ChannelMessageImpl[" +
      "channel=" +
      this.channel +
      "payLoad=" +
      this.payLoad +
      "startTime=" +
      this.startTime +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
